import { Component, type ReactNode } from 'react';

/** Keep a failed page or stale deployment chunk from leaving an empty app. */
export class AppRecovery extends Component<{children:ReactNode},{failed:boolean}> {
  state={failed:false};
  static getDerivedStateFromError(){return {failed:true};}
  render(){
    if(this.state.failed)return <main className="p-8"><h1 className="text-xl font-semibold">ATLAS could not finish loading</h1><p className="my-3">Reload to get the latest version. If this continues, try a private window.</p><button className="btn-primary" onClick={()=>window.location.reload()}>Reload ATLAS</button></main>;
    return this.props.children;
  }
}
